import { defineMessages } from 'react-intl'

const messages = defineMessages({
  back: {
    id: 'global.back',
  },
  confirmOffer: {
    id: 'global.confirm-offer',
  },
  confirm: {
    id: 'global.confirm',
  },
  importantInformation: {
    id: 'global.confirm-conditions',
  },
  importantInformationTitle: {
    id: 'global.important-information',
  },
})

export default messages
